import { motion } from "framer-motion";
import { ChapterHeading } from "@/components/ChapterHeading";
import { MACHINERY } from "@/data/profile";

export const Machinery = () => (
  <section id="machinery" data-testid="machinery-section" className="border-t hairline py-24 md:py-40">
    <div className="px-6 md:px-12">
      <ChapterHeading num="05" label="Machinery & tools" title={["The iron I know", "by hand"]} />
    </div>
    <div className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-t hairline">
      {MACHINERY.map((m, i) => (
        <motion.figure
          key={m.id}
          data-testid={`machinery-${m.id}`}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-5% 0px" }}
          transition={{ duration: 0.7, delay: i * 0.07, ease: [0.76, 0, 0.24, 1] }}
          className="group relative m-0 border-r border-b hairline overflow-hidden aspect-[3/4]"
        >
          <img src={m.image} alt={m.name} loading="lazy" className="img-treat absolute inset-0 h-full w-full object-cover group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1b2229]/90 via-[#1b2229]/10 to-transparent" />
          <span className="absolute top-4 left-4 eyebrow !text-white/70">0{i + 1}</span>
          <figcaption className="absolute inset-x-0 bottom-0 p-4 md:p-5 text-white">
            <div className="font-display uppercase text-lg md:text-xl leading-none">{m.name}</div>
            <div className="eyebrow !text-[var(--accent-2)] mt-2 normal-case tracking-normal text-[0.65rem]">{m.spec}</div>
          </figcaption>
        </motion.figure>
      ))}
    </div>
  </section>
);
